import {getUrlSearch} from '@/utils/getUrlSearch';

export const useHaboInfo = () => {
  const searchJson: { [key: string]: string } = getUrlSearch();

  // 埋点参数
  const cmsCode = (searchJson.cmsCode as string) && (searchJson.cmsCode as string) !== 'null'
    ? (searchJson.cmsCode as string)
    : '';
  const contentCode = (searchJson.contentCode as string) && (searchJson.contentCode as string) !== 'null'
    ? (searchJson.contentCode as string)
    : '';

  return {cmsCode, contentCode};
};
